<div class="panel-options-body overflow-wrapper theme-setting-panel">
    <div class="form form-horizontal">
        <div class="form-row">
            @for (colorName of colorNames; track colorName; let i = $index) {
                <div class="form-group mb-20">
                    <div class="col-xs-10">
                        <label>{{ COLOR_NAME_TRANSLATIONS[colorName] | translate }}</label>
                        <div class="text-muted small">{{ COLOR_DESCRIPTION_TRANSLATIONS[colorName] | translate }}</div>
                    </div>
                    <div class="col-xs-2">
                        <sp-color-picker-v2
                            [hideGradient]="true"
                            [isDropup]="i === 3 || i === 4"
                            [color]="form[colorName]().value()"
                            (colorChangeEvent)="onChangeColor(colorName, $event)"
                        />
                    </div>
                </div>
            }
        </div>
    </div>
</div>

<div class="panel-options-footer">
    <button type="button" class="btn btn-default mr-10" (click)="onCancel()">{{ "cancel" | translate }}</button>
    <button type="button" class="btn btn-success" (click)="onSave()">{{ "save" | translate }}</button>
</div>
